import React from 'react';
import styles from './TopicDeprecated.module.scss';
import { SFButton } from 'sfui';
import { useNavigate } from 'react-router-dom';
import { Topic } from '../../../Models';

export interface TopicDeprecatedProps {
  topic: Topic;
}

export const TopicDeprecated = ({
  topic
}: TopicDeprecatedProps): React.ReactElement<TopicDeprecatedProps> => {
  const navigate = useNavigate();

  const message: string = `This topic was deprecated${
    topic.is_replaced_with ? ' and replaced' : ''
  }.`;

  return (
    <div className={styles.topicDeprecated}>
      <h2 className={styles.title}>{topic.name}</h2>

      <div className={styles.message}>{message}</div>

      {topic.is_replaced_with && (
        <div className={styles.replace}>
          <h3>Here is the topic that could help you:</h3>
          <SFButton
            variant="outlined"
            size="large"
            onClick={() => navigate(`/topic/${topic.is_replaced_with}`)}
          >
            Go to the Topic
          </SFButton>
        </div>
      )}
    </div>
  );
};
